export const styles = {
  tooltipContent: {
    textOverflow: 'ellipsis',
    display: 'block',
    overflow: 'hidden',
  },
};
